import React from "react";
export default function SVGTank() {
  return (
    <svg height="512" viewBox="0 0 510 510" width="512">
      <g fill="#000000" id="XMLID_783_">
        <path
          fill="#000000"
          opacity="0.5"
          id="XMLID_825_"
          d="m105 450.098c-16.542 0-30 13.457-30 30 1.508 39.745 58.498 39.734 60 0 0-16.543-13.458-30-30-30z"
        />
        <path
          fill="#000000"
          opacity="0.5"
          id="XMLID_1010_"
          d="m405 450.098c-16.542 0-30 13.457-30 30 1.508 39.745 58.498 39.734 60 0 0-16.543-13.458-30-30-30z"
        />
        <path
          fill="#000000"
          opacity="0.5"
          id="XMLID_1011_"
          d="m330 255.098h60v60h-60z"
        />
        <path
          fill="#000000"
          opacity="0.5"
          id="XMLID_1012_"
          d="m330 60.098h60v75h-60z"
        />
        <path
          fill="#000000"
          opacity="0.5"
          id="XMLID_1014_"
          d="m330 165.098h60v60h-60z"
        />
        <path
          fill="#000000"
          id="XMLID_1016_"
          d="m510 210.098v-45c0-52.805-39.184-96.623-90-103.924v252.848c50.816-7.301 90-51.119 90-103.924z"
        />
        <path
          fill="#000000"
          id="XMLID_1067_"
          d="m390 315.098v45h-60v-45h-30v45h-150v-45h150c0-9.776 0-271.084 0-285h30v-30c-18.838 0-134.387 0-150 0v30h30v30h-105c-57.896 0-105 47.104-105 105v45c0 57.897 47.104 105 105 105h15v45h-120v105h46.898c16.002-59.64 100.224-59.6 116.203 0h183.797c16.002-59.64 100.224-59.6 116.203 0h46.899v-105h-90v-46.076c-11.219 1.612-17.981.898-30 1.076zm-225-191.393c12.427 18.006 45 63.188 45 86.393 0 24.812-20.186 45-45 45-24.812 0-45-20.188-45-45 0-23.23 32.669-68.526 45-86.393z"
        />
        <path
          fill="#000000"
          id="XMLID_1068_"
          d="m165 225.098c8.268 0 14.994-6.723 15-14.988-.128-4.59-6.365-17.655-15-32.205-8.639 14.555-14.878 27.626-15 32.211 0 8.253 6.729 14.982 15 14.982z"
        />
      </g>
    </svg>
  );
}
